import { utl_parseData, html } from "../base/_utils";
import Papa from "papaparse";
import Modal from "bootstrap/js/dist/modal";

async function getAndDisplayData(dataRef) {
    const calendarEventsData = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQlThNVSp1zukIrwKllbophSol64UiYfDTBWU_nMrxQAXQPYGKLlp2_Kw79dzEWyRx7jo9Wnn7YN81u/pub?output=csv";
    const otherEventsData = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQlThNVSp1zukIrwKllbophSol64UiYfDTBWU_nMrxQAXQPYGKLlp2_Kw79dzEWyRx7jo9Wnn7YN81u/pub?gid=1838069297&single=true&output=csv";

    let results;
    let data;

    try {
        if (dataRef === "calendarEvents") {
            // 'await' allows/prevents execution of parseData() depending on resolution/rejection of Promise(from parseData())
            results = await utl_parseData(calendarEventsData, Papa);
            data = results.data;

            for (let i = 0; i < data.length; i++) {
                document.getElementById("calendar-events-list").innerHTML += html`
                    <td>${data[i].date}</td>
                    <td>${data[i].event}</td>
                    <td>${data[i].cityState}</td>
                    <td>${data[i].contactPerson}</td>
                    <td><a href="mailto:${data[i].email}">${data[i].email}</a></td>
                    <td>
                        <a target="_blank" href="${data[i].link1}">${data[i].info1}</a><br />
                        <a target="_blank" href="${data[i].link2}">${data[i].info2}</a>
                    </td>
                `;
            }
        } else if (dataRef === "otherEvents") {
            // Additional Donors
            results = await utl_parseData(otherEventsData, Papa);
            data = results.data;

            for (let i = 0; i < data.length; i++) {
                document.getElementById("other-calendar-events-list").innerHTML += html`
                    <td>${data[i].date}</td>
                    <td>${data[i].event}</td>
                    <td>${data[i].cityState}</td>
                    <td>${data[i].contactPerson}</td>
                    <td><a href="mailto:${data[i].email}">${data[i].email}</a></td>
                    <td>
                        <a target="_blank" href="${data[i].link1}">${data[i].info1}</a><br />
                        <a target="_blank" href="${data[i].link2}">${data[i].info2}</a>
                    </td>
                `;
            }
        }
    } catch (error) {
        // If Promise rejects, log the error
        console.error("Error parsing data:", error);
    }
}

getAndDisplayData("calendarEvents");
getAndDisplayData("otherEvents");
